/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(document).ready(function(){
function cartCountNew(){
  jQuery.getJSON('/cart.js', function(cart) {
    var c_count = cart.item_count;
    // console.log('Cart item count:', cart.item_count);
    jQuery(".cart_menu span.Header__CartCount").text(c_count)
    if(c_count == 0){
       jQuery(".cart_menu .Header__CartDot").removeClass("is-visible")
    }
    if(c_count > 0){
       jQuery(".cart_menu .Header__CartDot").addClass("is-visible")
    }
  });
}
  cartCountNew();

  setInterval(()=>{
    cartCountNew();
  }, 4000)
  
  jQuery(".our_groom.Container .shopify-section.shopify-section--bordered").each(function(){
    var title=jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').text();
          jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').attr('id',title);  
    
     jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').addClass('h2_custom');  
     
  });
  
   jQuery(".our_groom.Container .shopify-section.shopify-section--bordered .ProductItem__Wrapper").mouseenter(function(){
    var title=jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').text();
          jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').attr('id',title);  
    
     jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').slideDown(); 
        jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').animate({top: "0"});
     
  });
  
  
  
    jQuery(".our_groom.Container .shopify-section.shopify-section--bordered .ProductItem__Wrapper").mouseleave(function(){
    var title=jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').text();
          jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').attr('id',title);  
    
     jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').slideUp(); 
         jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').animate({top: "100%"}); 
     
  });
    jQuery(".all_cateogy_groom a").click(function(){
   
   jQuery(".all_cateogy_groom a").removeClass('active');
   jQuery(this).addClass('active');
  
});

  // Ensure "View product" control on Globo filter cards opens the same PDP as the product image
  jQuery(document).on('click', '.ProductItem__ViewProduct button, .ProductItem__ViewProduct a', function(e){
    e.preventDefault();
    var $card = jQuery(this).closest('.spf-product-card');
    var $imageLink = $card.find('.spf-product-card__image-wrapper').first();
    if ($imageLink.length) {
      window.location.href = $imageLink.attr('href');
    }
  });

  // AJAX Add to Cart for collection page ProductItem__AddToCartForm
  jQuery(document).on('submit', '.ProductItem__AddToCartForm', function(e) {
    e.preventDefault();
    var $form = jQuery(this);
    var $button = $form.find('.ProductItem__AddToCart');
    var variantId = $form.find('input[name="id"]').val();
    var originalText = $button.text();
    
    // Disable button and show loading
    $button.prop('disabled', true).text('Adding...');
    
    // Add to cart via AJAX
    jQuery.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        id: variantId,
        quantity: 1
      }),
      success: function(item) {
        // Update cart count
        cartCountNew();
        
        // Show success message
        $button.text('Added!').addClass('Button--success');
        
        // Dispatch event for theme compatibility
        document.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            variant: item,
            quantity: 1
          }
        }));
        
        // Reset button after 2 seconds
        setTimeout(function() {
          $button.prop('disabled', false).text(originalText).removeClass('Button--success');
        }, 2000);
      },
      error: function(xhr, status, error) {
        // Show error
        $button.text('Error').addClass('Button--error');
        console.error('Add to cart error:', error);
        
        // Reset button after 2 seconds
        setTimeout(function() {
          $button.prop('disabled', false).text(originalText).removeClass('Button--error');
        }, 2000);
      }
    });
  });

  // Fix price display issue - correct prices showing 10x (400,000 instead of 40,000)
  function fixPriceDisplay() {
    // If we are on the Taupe Pintuck Kurta PDP, never auto-correct prices
    try {
      if (window.location && window.location.pathname && window.location.pathname.indexOf('/products/taupe-pintuck-kurta-set') !== -1) {
        return;
      }
    } catch (e) {
      // fail safe – continue normal logic
    }

    // Fix prices with data-money-convertible attribute
    jQuery('[data-money-convertible]').each(function() {
      var $priceEl = jQuery(this);
      var priceText = $priceEl.text().trim();
      var shopCurrency = (window.theme && window.theme.shopCurrency) ? window.theme.shopCurrency : 'INR';
      
      // Get original price from data attribute (before currency conversion)
      var originalPriceAttr = $priceEl.attr('data-currency-' + shopCurrency);
      if (!originalPriceAttr) {
        // If no original price stored, store current as original
        $priceEl.attr('data-currency-' + shopCurrency, priceText);
        return;
      }
      
      // Extract numbers from both prices
      var currentNum = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
      var originalNum = parseFloat(originalPriceAttr.replace(/[^0-9.]/g, '')) || 0;
      
      // If current price is exactly 10x the original, fix it
      if (originalNum > 0 && currentNum > 0 && Math.abs(currentNum - (originalNum * 10)) < 1) {
        // Restore original price
        $priceEl.text(originalPriceAttr);
        // Mark as already converted to prevent re-conversion
        $priceEl.attr('data-currency', shopCurrency);
      }
    });

    // Globo Filter prices are fixed by script below (product JSON) - no heuristic correction here
  }

  // Run fix after a short delay to allow currency conversion to complete
  setTimeout(fixPriceDisplay, 500);
  
  // Run fix after currency conversion events
  if (window.theme && window.theme.currencyConversionEnabled) {
    // Fix prices when currency selector changes
    jQuery(document).on('change', '.CurrencySelector__Select', function() {
      setTimeout(fixPriceDisplay, 500);
    });
    
    // Override currency conversion to fix prices after conversion
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixPriceDisplay, 1000);
    });
  }

  // Format price for display – same as product page (Shopify API returns price in smallest unit, theme divides by 100)
  function formatPriceFromAPI(price, formatStr) {
    if (price == null || isNaN(price)) return '';
    formatStr = formatStr || (window.GloboMoneyFormat || 'Rs. {{amount}}');
    var raw = typeof price === 'string' ? parseFloat(price.replace(/[^0-9.]/g, '')) : Number(price);
    var num = raw / 100; // product page uses formatMoney(cents) which does /100
    var formatted = num.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 0 });
    return formatStr.replace(/\{\{\s*amount[^}]*\}\}/g, formatted).replace(/\{\{\s*amount_no_decimals[^}]*\}\}/g, Math.round(num).toLocaleString('en-IN'));
  }

  // Set collection page prices from product JSON (same as product page) so script-rendered prices are correct
  function setGloboPricesFromProductJSON() {
    var cards = document.querySelectorAll('.spf-product-card');
    if (!cards.length) return;
    var formatStr = (window.GloboMoneyFormat || window.theme && window.theme.moneyFormat || 'Rs. {{amount}}');
    var cache = window._globoPriceCache = window._globoPriceCache || {};

    cards.forEach(function(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?]+)/);
      if (!match) return;
      var handle = match[1];
      var $card = jQuery(card);
      var $priceWrapper = $card.find('.spf-product-card__price-wrapper');
      var $mainPrice = $card.find('.spf-product-card__price');
      var $salePrice = $card.find('.spf-product-card__saleprice');
      var $oldPrice = $card.find('.spf-product-card__oldprice');
      if (!$mainPrice.length && !$salePrice.length) return;
      if ($priceWrapper.attr('data-price-from-json') === 'true') return;

      function applyPrice(product) {
        if (!product || !product.variants || !product.variants.length) return;
        var v = product.selected_or_first_available_variant || product.variants[0];
        var price = v.price;
        var compareAt = v.compare_at_price;
        var isSale = compareAt && compareAt > price;

        if (isSale && $oldPrice.length && $salePrice.length) {
          $oldPrice.text(formatPriceFromAPI(compareAt, formatStr));
          $salePrice.text(formatPriceFromAPI(price, formatStr));
        } else if ($mainPrice.length) {
          $mainPrice.text(formatPriceFromAPI(price, formatStr));
        }
        $priceWrapper.attr('data-price-from-json', 'true');
      }

      if (cache[handle]) {
        applyPrice(cache[handle]);
        return;
      }
      jQuery.getJSON('/products/' + handle + '.js')
        .done(function(product) {
          cache[handle] = product;
          applyPrice(product);
        })
        .fail(function() {});
    });
  }

  // Fix prices when Globo Filter renders products: use product JSON so price matches product page
  if (window.addEventListener) {
    window.addEventListener('globoFilterRenderCompleted', function() {
      setTimeout(function() { setGloboPricesFromProductJSON(); fixPriceDisplay(); }, 100);
      setTimeout(function() { setGloboPricesFromProductJSON(); fixPriceDisplay(); }, 500);
      setTimeout(function() { setGloboPricesFromProductJSON(); fixPriceDisplay(); }, 1200);
    });
  }

  // On collection/search page load, fix Globo prices from product JSON (same as product page)
  if (window.theme && (window.theme.template === 'collection' || window.theme.template === 'search')) {
    setTimeout(setGloboPricesFromProductJSON, 400);
    setTimeout(setGloboPricesFromProductJSON, 1500);
  }

  // Fix prices on dynamic content load (for AJAX-loaded products)
  var observer = new MutationObserver(function() {
    setTimeout(fixPriceDisplay, 300);
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // When new Globo product cards appear (e.g. load more, filter), set prices from product JSON
  setInterval(function() {
    var $wrapper = jQuery('.spf-product-card__price-wrapper').filter(function() {
      return jQuery(this).attr('data-price-from-json') !== 'true';
    });
    if ($wrapper.length > 0) {
      setGloboPricesFromProductJSON();
    }
  }, 1500);
  });